import React, { useState } from 'react';
import { Calendar as CalendarIcon, Clock, ArrowRight, CheckCircle2, Video } from 'lucide-react';
import { Calendar } from './ui/calendar';
import { useToast } from '../hooks/use-toast';

const TIMES = ['09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM', '04:00 PM', '04:30 PM'];

export default function BookingSection() {
  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState('10:00 AM');
  const { toast } = useToast();

  const submit = (e) => {
    e.preventDefault();
    toast({
      title: 'Demo Booked!',
      description: `We\u2019ll see you on ${date.toDateString()} at ${time}.`,
    });
  };

  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#f0fdf4] relative overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-40" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 fade-in">
          <div className="inline-block text-sm font-bold tracking-[0.25em] uppercase text-neutral-600 mb-3">Start Your Free Demo Today</div>
          <h2 className="text-4xl md:text-5xl font-black text-black mb-4">Book Your Personalized Walkthrough</h2>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto">Submit the form and start your 14 days free trial today.</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {/* Left card */}
          <div className="lg:col-span-1 rounded-3xl bg-black text-white p-8 fade-in">
            <div className="w-14 h-14 rounded-2xl bg-[#22c55e] flex items-center justify-center mb-5">
              <Video className="w-7 h-7 text-black" />
            </div>
            <div className="text-xs font-bold tracking-[0.2em] text-[#22c55e] uppercase mb-2">30 Min Session</div>
            <h3 className="text-2xl font-black mb-3">Book a Demo with Xxpand Expert</h3>
            <p className="text-neutral-400 text-sm mb-6">Schedule a demo to see Xxpand in action.</p>

            <ul className="space-y-3">
              {['A live walkthrough of key features', 'Answers to all your questions', 'Insights on how Xxpand fits your needs'].map((t) => (
                <li key={t} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-neutral-200">{t}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 pt-6 border-t border-neutral-800 flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-[#22c55e] flex items-center justify-center font-black text-black">US</div>
              <div>
                <div className="font-bold text-sm">Umer Samana</div>
                <div className="text-xs text-neutral-400">Xxpand Product Expert</div>
              </div>
            </div>
          </div>

          {/* Right form */}
          <form onSubmit={submit} className="lg:col-span-2 rounded-3xl bg-white p-8 border border-neutral-200 shadow-xl fade-in">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <div className="flex items-center gap-2 mb-4">
                  <CalendarIcon className="w-4 h-4 text-neutral-500" />
                  <span className="text-sm font-bold text-neutral-700">Select Date</span>
                </div>
                <div className="rounded-xl border border-neutral-200 p-2">
                  <Calendar mode="single" selected={date} onSelect={(d) => d && setDate(d)} className="w-full" />
                </div>
              </div>

              <div>
                <div className="flex items-center gap-2 mb-4">
                  <Clock className="w-4 h-4 text-neutral-500" />
                  <span className="text-sm font-bold text-neutral-700">Select Time</span>
                </div>
                <div className="grid grid-cols-2 gap-2 max-h-[280px] overflow-y-auto pr-1">
                  {TIMES.map((t) => (
                    <button
                      type="button"
                      key={t}
                      onClick={() => setTime(t)}
                      className={`py-2.5 rounded-lg font-semibold text-sm border transition-all ${time === t ? 'bg-black text-white border-black' : 'bg-white text-black border-neutral-200 hover:border-[#22c55e]'}`}
                    >
                      {t}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4 mt-8">
              <input required placeholder="Your Name" className="px-4 py-3 rounded-xl border border-neutral-200 focus:border-black focus:outline-none focus:ring-2 focus:ring-[#22c55e]/40 text-sm" />
              <input required type="email" placeholder="Work Email" className="px-4 py-3 rounded-xl border border-neutral-200 focus:border-black focus:outline-none focus:ring-2 focus:ring-[#22c55e]/40 text-sm" />
              <input placeholder="Company" className="px-4 py-3 rounded-xl border border-neutral-200 focus:border-black focus:outline-none focus:ring-2 focus:ring-[#22c55e]/40 text-sm" />
              <input placeholder="Phone Number" className="px-4 py-3 rounded-xl border border-neutral-200 focus:border-black focus:outline-none focus:ring-2 focus:ring-[#22c55e]/40 text-sm" />
            </div>

            <button className="cta-btn mt-6 w-full md:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#22c55e] text-black rounded-full font-bold text-[15px] shadow-lg">
              Confirm Booking <ArrowRight className="w-4 h-4" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
